import { render, staticRenderFns } from "./DonutIcon.vue?vue&type=template&id=377281cd&"
import script from "./DonutIcon.vue?vue&type=script&lang=js&"
export * from "./DonutIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports